<template>
  <b-form @submit.prevent="guardar">
    <b-form-group label="Nombre">
      <b-form-input v-model="motivo.nombre" placeholder="Nombre del motivo" autofocus required />
    </b-form-group>
    <b-form-group label="Usos">
      <b-form-checkbox switch size="lg" v-model="motivo.paraGanar" value="1"> Para ganar </b-form-checkbox>
      <b-form-checkbox switch size="lg" v-model="motivo.paraPerder" value="1"> Para perder </b-form-checkbox>
    </b-form-group>

    <b-form-group label="Observaciones">
      <b-form-input v-model="motivo.observaciones" placeholder="Nombre del motivo" />
    </b-form-group>

    <botonera-edicion @cancelar="volver()" />
  </b-form>
</template>

<script>
export default {
  props: {
    motivo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    volver() {
      this.$router.push("/motivosCierreOferta");
    },
    async guardar() {
      await this.$backend.post("/motivosCierreOferta/guardar", this.motivo);
      this.$messages.success("Motivo de cierre guardado correctamente");
      this.volver();
    },
  },
};
</script>
